import React, { useEffect, useState } from "react";
import { dispatchStore } from "../lib/dispatchStore";
import { saleReportSlice } from "../helper/customSlice";

const DateFilter = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  getSaleReport,
}) => {
  return (
    <>
      {/* Date inputs grouped */}
      <div className="flex flex-col md:flex-row gap-4 ">
        <div>
          <label className="block text-gray-700 mb-2">From Date:</label>
          <input
            type="date"
            className="border-[1px] border-gray-300 rounded-md px-2 py-1 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
            value={fromDate}
            onChange={(e) => {
              setFromDate(e.target.value);
              dispatchStore(saleReportSlice.actions.setListpage(1));
            }}
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2">To Date:</label>
          <input
            type="date"
            className="border-[1px] border-gray-300 rounded-md px-2 py-1 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
            value={toDate}
            onChange={(e) => {
              setToDate(e.target.value);
              dispatchStore(saleReportSlice.actions.setListpage(1));
              if (getSaleReport) getSaleReport();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default DateFilter;
